import React, { useEffect, useState } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Divider, Paper, Typography } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import UnoButton from "../../utils/UnoButton";
import { unoTheme } from "../../../assets/styles/unoTheme";

//Tables
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../../utils/MyTable';
import MyTextField from "../../utils/MyTextField";

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import EventIcon from '@material-ui/icons/Event';
import Switch from '@material-ui/core/Switch';

import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import CircularProgress from '@material-ui/core/CircularProgress';

import {
    getArrayMonthsWithNames,
    applyMaskAmount,
    applyMaskAmountFreeDecimals,
    applyMaskAccount,
    parseFloatByPtCurrency,
    isDateAfterClosedMonth,
    getOperationLabel,
    greenOrRed,
    getOperationColor
} from "../../utils/utils";
import { ClientAPI } from "../../../API/client";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import _ from 'lodash';

import NewAssetTitle from "./NewAssetTitle";

import moment from 'moment'
import { isConsigTitle, isGenericTitle } from "../../../controllers/TitleController";
import { TitleAPI } from "../../../API/title";

const GreenSwitch = withStyles({
    switchBase: {
        //color: unoTheme.greenMoney,
        '&$checked': {
            color: unoTheme.greenMoney,
        },
        '&$checked + $track': {
            backgroundColor: unoTheme.greenMoney,
        },
    },
    checked: {},
    track: {},
})(Switch);

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
        backgroundColor: unoTheme.hoverTable,
    },

    main: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',

        '& .MuiTableContainer-root': {
            height: 'calc(100% - 218px)',
        },

        '& .MuiTableHead-root': {
            '& .MuiTableCell-head': {

                //background: `${unoTheme.hoverTable} !important`,
            }
        }
    },

    leftPadding24: {
        paddingLeft: theme.spacing(3),
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        height: '70px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        height: 'calc(100% - 1px)',


        // '& .MuiTableRow-root': {

        //     borderRadius: '10px',

        //     '&:nth-of-type(odd)': {
        //         backgroundColor: unoTheme.secondaryTuplaTable,
        //         //backgroundColor: 'red',
        //     }
        // },

        '& .MuiTableHead-root': {
            '& .MuiTableCell-root': {
                background: 'white',
            }
        }
    },

    detailRow: {
        cursor: "pointer",
        '& > *': {
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },

        '& .MuiTableCell-root:first-child': {
            paddingLeft: '24px !important',
        }
        // '&:nth-of-type(odd)': {
        //     backgroundColor: unoTheme.secondaryTuplaTable,
        // },

    },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'column',
        //alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },

    headerDate: {
        display: 'flex',
        alignItems: 'center',
        color: unoTheme.secondaryColor,
        fontSize: '12px',
        '& svg': {
            marginRight: '5px',
        },
        '& > *': {
            fontSize: '14px',
        }
    },

    accountLabel: {
        fontSize: '14px',
        color: unoTheme.secondaryColor,
    },

    fundLabel: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#1C2228'
    },

    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },

    tabsAsset: {
        background: '#F3F5F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    bold: {
        fontWeight: 'bold',
        cursor: 'pointer',

        '&:hover': {
            opacity: 0.7,
        }
    },

    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },


}));

export default function DetailBalanceTitleValidation(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const { content } = props;

    const [disableAll, setDisableAll] = useState(false);

    const [openBackdrop, setOpenBackdrop] = useState(false);

    //Tab de saldos do ano ou descrição do ativo
    const [tabValue, setTabValue] = useState(0); //detail
    function handleChangeTabValue(event, value) {
        setTabValue(value)
    }

    const [months, setMonths] = useState(getArrayMonthsWithNames())

    const [inputs, setInputs] = useState([
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
    ]);

    //const [initInputs, setInitInputs] = useState(undefined);

    console.log("DATA SELECIONADA: ", content)

    function initInputs(data) {


        let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        let newInputs = []

        months.forEach(m => {

            let dataLoop = data.yearValidation.months[m];

            console.log("dataLoop: ", dataLoop);

            if (dataLoop) {
                newInputs.push({
                    balance_title_validation_id: dataLoop.id,
                    month: m,
                    //Atributo que indica se esse mês de carteira já fechada
                    isAlreadyLaunched: !isDateAfterClosedMonth(
                        moment.utc(new Date(dataLoop.year_validation, dataLoop.month_validation - 1, 1)).format("DD/MM/YYYY"),
                        clientOn.client.portfolio_closed,
                        false
                    ),
                    balance: dataLoop.balance ? applyMaskAmount(dataLoop.balance) : '',
                    quota_amount: dataLoop.quota_amount ? applyMaskAmountFreeDecimals(dataLoop.quota_amount) : '',
                    registred_rent: dataLoop.registred_rent ? applyMaskAmountFreeDecimals(dataLoop.registred_rent) : '',
                    status: dataLoop.balance ? true : false,
                })
            } else {
                newInputs.push({
                    balance_title_validation_id: null,
                    month: m,
                    //Atributo que indica se esse mês de carteira já fechada
                    isAlreadyLaunched: false,
                    balance: dataLoop && dataLoop.balance ? applyMaskAmount(dataLoop.balance) : '',
                    quota_amount: dataLoop && dataLoop.quota_amount ? applyMaskAmountFreeDecimals(dataLoop.quota_amount) : '',
                    registred_rent: dataLoop && dataLoop.registred_rent ? applyMaskAmountFreeDecimals(dataLoop.registred_rent) : '',
                    status: dataLoop && dataLoop.balance ? true : false,
                })
            }


        });

        console.log("NEW INPUTS: ", newInputs)
        console.log("MONTHS: ", months)
        setInputs(newInputs);

        const hasDisabledRoles = currentUser?.user?.isManager || currentUser?.user?.isSubManager || currentUser?.user?.isViewer;

        if (hasDisabledRoles) {
            setDisableAll(true)
        }

    }

    function handleChangeBalanceInput(value, index) {

        let newInputs = [...inputs]
        newInputs[index].balance = value
        newInputs[index].statusChange = true
        setInputs(newInputs);
    }

    function handleChangeQuotaInput(value, index) {

        let newInputs = [...inputs]
        newInputs[index].quota_amount = value
        newInputs[index].statusChange = true
        setInputs(newInputs);
    }

    function handleChangeRentInput(value, index) {

        let newInputs = [...inputs]
        newInputs[index].registred_rent = value
        newInputs[index].statusChange = true
        setInputs(newInputs);
    }

    function changeStatusBalance(e, index) {

        console.log("STATUS: ", e.target.checked)

        let value = e.target.checked;

        let newInputs = [...inputs]

        newInputs[index].status = value
        if (!value) {
            newInputs[index].statusChange = false
        }

        console.log("NEW INPUTS: ", newInputs)
        setInputs(newInputs);
    }

    async function doSaveBalancesValidations(ipts, year) {

        setOpenBackdrop(true)

        //let filterStatusOk = ipts.filter(el => el.status || el.statusChange)
        console.log("TO SAVE BALANCES: ", ipts);
        //São filtrados os objetos que sofreram alteração e que estão com status de OK
        let filterStatusOk = ipts.filter(el => el.statusChange)
        console.log("TO SAVE BALANCES: ", filterStatusOk);

        let allSuccess = true;
        for (let i = 0; i < filterStatusOk.length; i++) {

            let balanceToSave = {
                //Caso seja um update de um balanço já criado
                balance_title_validation_id: filterStatusOk[i].balance_title_validation_id,
                //Caso seja um balanço de ativo
                title_asset_id: content.data.id,
                //O mês do balanço
                month_validation: filterStatusOk[i].month,
                //O ano do balanço
                year_validation: year,
                //Valor do balanço
                balance: parseFloatByPtCurrency(filterStatusOk[i].balance),

                quota_amount: filterStatusOk[i].quota_amount ? parseFloatByPtCurrency(filterStatusOk[i].quota_amount) : null,
                registred_rent: filterStatusOk[i].registred_rent ? parseFloatByPtCurrency(filterStatusOk[i].registred_rent) : null,
            }

            console.log("BALANCE TO SAVE: ", balanceToSave);

            let response = await ClientAPI.createBalanceTitleValidation(balanceToSave)

            if (!response.success) {
                allSuccess = false
            }
        }

        setOpenBackdrop(false)
        dispatch(allActions.rightContentActions.update())

        if (allSuccess) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Saldos cadastrados com sucesso!'
            }))

        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Falha ao cadastrar saldos!'
            }))
        }

    }

    function copyToClipboard(e, text) {
        e.stopPropagation();
        navigator.clipboard.writeText(text);
        dispatch(allActions.mainAlertActions.setMainAlert({
            type: 'success',
            message: 'Informação copiada para área de transferência!',
            show: true,
        }));
    };

    const [assetTitlesTransactions, setAssetTitlesTransactions] = useState(null);

    useEffect(() => {
        const fetchTransactions = async () => {
            if (assetTitlesTransactions != null) return;
            if (tabValue !== 2) return;

            try {
                const response = await TitleAPI.getTransactionsByAssetsTitlesIdsAndPeriod(
                    [content.data.id],
                    "01/01/2000",
                    "31/12/2100"
                );
                if (response.success) {

                    setAssetTitlesTransactions(response.body.rows);
                }
            } catch (error) {
                console.error("Erro ao buscar transações:", error);
            }
        };

        fetchTransactions();
    }, [tabValue, content.data.id]);

    useEffect(() => {
        console.log("USE EFFECT")
        if (content && content.data) {

            //console.log("DATA: ", content)
            console.log("DATA: ", content.data)
            initInputs(content.data);

        }
    }, [])

    return (

        <div className={classes.root}>


            <Paper style={{ marginBottom: '4px' }}>
                <div className={classes.header}>

                    <div className={classes.leftHeader}>

                        <Typography
                            align={'left'}
                            className={classes.fundLabel}>
                            {content && content.data && content.data ?
                                (!isGenericTitle(content.data) ? (content.data.title_name + " ( " + content.data.marking + " )") : content.data.title_name)

                                : ""}
                        </Typography>
                        {content && content.data && content.data ?
                            <Typography
                                align={'left'}
                                className={classes.accountLabel}>
                                <span>{"Ag: " + (content.data.agency ? content.data.agency : '-')}</span>
                                <span className={classes.spacingLeft2}>{"CC: " + applyMaskAccount(content.data.number_account)}</span>

                            </Typography>
                            : null
                        }

                    </div>

                    <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                        <CloseIcon />
                    </IconButton>

                </div>


                <Paper square className={classes.tabsAsset}>
                    <Tabs
                        value={tabValue}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChangeTabValue}>
                        <Tab label={<span style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}><EventIcon /> <span style={{ marginLeft: '5px' }}>{" Saldos " + (content && content.data && content.selectedYear ? content.selectedYear : "")}</span></span>} />

                        {content && content.data
                            && !content.data.account_init ?
                            <Tab label="Detalhe" />
                            : null
                        }

                        {content && content.data
                            && !content.data.account_init ?
                            <Tab label="Movimentações" />
                            : null
                        }

                    </Tabs>

                    <div className={[classes.lastsBalancesInfo, classes.spacingRight2].join(' ')}>
                        <span className={classes.spacingLeft2}>
                            Últ. Saldo:
                        </span>
                        <span
                            onClick={(e) => copyToClipboard(e, applyMaskAmount(content?.data?.yearValidation?.lastBalance?.balance))}
                            className={[classes.bold, classes.spacingLeft1].join(' ')}>{applyMaskAmount(content?.data?.yearValidation?.lastBalance?.balance, true)}</span>
                        <span className={classes.spacingLeft2}>
                            Últ. Cotas:
                        </span>
                        <span
                            onClick={(e) => copyToClipboard(e, applyMaskAmount(content?.data?.yearValidation?.lastBalance?.quota_amount, null, 6))}
                            className={[classes.bold, classes.spacingLeft1].join(' ')}>{applyMaskAmountFreeDecimals(content?.data?.yearValidation?.lastBalance?.quota_amount, null, 6)}</span>
                    </div>
                </Paper>



            </Paper>
            {tabValue == 0 &&
                <div className={classes.main}>


                    <TableContainer component={Paper} elevation={0}>
                        <Table className={classes.table}
                            stickyHeader
                            size="small">

                            <colgroup>
                                <col width="25%" />
                                <col width="35%" />
                                <col width="25%" />
                                <col width="15%" />
                            </colgroup>

                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.leftPadding24} align="left">MÊS</TableCell>
                                    <TableCell align="center">SALDO</TableCell>

                                    <TableCell align="center">Q.COTAS</TableCell>

                                    {
                                        isConsigTitle(content?.data) ?
                                            <TableCell align="center">RENT.</TableCell> :
                                            null
                                    }

                                    {
                                        disableAll ? //Caso seja um usuário manager não há a necessidade de exivir a coluna de status
                                            null :
                                            <TableCell align="center">STATUS</TableCell>
                                    }

                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.table}>
                                {
                                    months.map((row, index) => (
                                        <>

                                            <TableRow className={classes.detailRow}
                                                key={'detail-month' + row.id}>

                                                <TableCell align="left">
                                                    {row.name}
                                                </TableCell>


                                                {/*VALOR DO SALDO*/}
                                                <TableCell align="left">
                                                    {

                                                        content && content.data && parseInt(row.id) >= content.data.yearValidation.init ?
                                                            <MyTextField
                                                                disabled={inputs[parseInt(row.id) - 1].status || disableAll}
                                                                align="right"
                                                                onChange={(value) => handleChangeBalanceInput(value, parseInt(row.id) - 1)}
                                                                value={inputs[parseInt(row.id) - 1].balance}
                                                                verysmall
                                                                placeholder="0.00"
                                                                //mask={["currency"]}
                                                                size={'small'}
                                                                variant="outlined" />
                                                            :
                                                            <Typography
                                                                align="center"
                                                                className={classes.smallText}>
                                                                {'-'}
                                                            </Typography>
                                                    }

                                                </TableCell>

                                                {/*VALOR QUANTIDADE DE QUOTAS*/}


                                                <TableCell align="left">
                                                    {

                                                        content && content.data && parseInt(row.id) >= content.data.yearValidation.init ?
                                                            <MyTextField
                                                                disabled={inputs[parseInt(row.id) - 1].status || disableAll}
                                                                align="right"
                                                                onChange={(value) => handleChangeQuotaInput(value, parseInt(row.id) - 1)}
                                                                value={inputs[parseInt(row.id) - 1].quota_amount}
                                                                verysmall
                                                                placeholder="0.00"
                                                                size={'small'}
                                                                variant="outlined" />
                                                            :
                                                            <Typography
                                                                align="center"
                                                                className={classes.smallText}>
                                                                {'-'}
                                                            </Typography>
                                                    }
                                                </TableCell>

                                                {
                                                    isConsigTitle(content?.data) ?

                                                        <TableCell align="center">
                                                            {content && content.data && parseInt(row.id) >= content.data.yearValidation.init ?
                                                                <MyTextField
                                                                    disabled={inputs[parseInt(row.id) - 1].status || disableAll}
                                                                    align="right"
                                                                    onChange={(value) => handleChangeRentInput(value, parseInt(row.id) - 1)}
                                                                    value={inputs[parseInt(row.id) - 1].registred_rent}
                                                                    verysmall
                                                                    placeholder="0.00"
                                                                    size={'small'}
                                                                    variant="outlined" />
                                                                :
                                                                <Typography
                                                                    align="center"
                                                                    className={classes.smallText}>
                                                                    {'-'}
                                                                </Typography>
                                                            }
                                                        </TableCell> : null

                                                }


                                                {

                                                    !disableAll ?
                                                        <>
                                                            {
                                                                //verificando se existe saldo pra esse mês
                                                                //Caso o row.id seja menor que o init (representa o mês do ano que iniciou o ativo)
                                                                //o switch deve ser disable

                                                                //Caso esse seja um mês em que a carteira já foi fechada exibe-se o disable
                                                                parseInt(row.id) >= content.data.yearValidation.init
                                                                    && !inputs[parseInt(row.id) - 1].isAlreadyLaunched ?

                                                                    <TableCell align="left" className={classes.flexCell}>
                                                                        <GreenSwitch
                                                                            checked={(inputs[parseInt(row.id) - 1].status
                                                                                || inputs[parseInt(row.id) - 1].statusChange)
                                                                                || (inputs[parseInt(row.id) - 1].status == undefined && inputs[parseInt(row.id) - 1].statusChange == undefined)}
                                                                            onChange={(e) => changeStatusBalance(e, parseInt(row.id) - 1)} />

                                                                    </TableCell>
                                                                    :

                                                                    //invalid
                                                                    <TableCell align="left" className={classes.flexCell}>
                                                                        <GreenSwitch
                                                                            disabled />
                                                                    </TableCell>
                                                            }
                                                        </> : null

                                                }



                                            </TableRow >
                                        </>
                                    ))

                                }
                            </TableBody>

                        </Table>
                    </TableContainer>

                    <Divider />

                    {
                        !disableAll && (currentUser && currentUser.user
                            && (currentUser.user.role == "ROLE_ADMIN"
                                || currentUser.user.role == "ROLE_SUPER_ADMIN"
                                || currentUser.user.role == "ROLE_ADVISOR")) ?

                            <div className={classes.bottom}>

                                <UnoButton
                                    onClick={() => doSaveBalancesValidations(inputs, content.selectedYear)}
                                    className={classes.spacingRight2}
                                    type='primary'
                                    size={'small'}>
                                    {"Salvar saldos"}
                                </UnoButton>
                            </div>
                            : null
                    }


                </div>
            }

            {
                tabValue == 1 &&
                <NewAssetTitle
                    content={{
                        update: true,
                        data: content.data,
                    }}
                />
            }

            {
                tabValue == 2 &&
                <MyTable
                    style={{ marginTop: '8px' }}
                    stickyHeader
                    infosBlack
                    sizeheaders="verySmall"
                    selectable={'true'}
                    size="small">
                    {/* <colgroup>
                        <col width="20%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="20%" />
                        <col width="13%" />
                        <col width="22%" />
                    </colgroup> */}
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableTh} align="center">Data</TableCell>
                            <TableCell className={classes.tableTh} align="center">Operação</TableCell>
                            {/* <TableCell className={classes.tableTh} align="center">Conta</TableCell> */}
                            {/* <TableCell className={classes.tableTh} align="right">Cotas</TableCell> */}
                            <TableCell className={classes.tableTh} align="right">Valor</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                            //content.data.transactions.map((row, index) => (
                            assetTitlesTransactions && assetTitlesTransactions.map((row, index) => (
                                //assetTitleTransactions.map((row, index) => (


                                <TableRow className={classes.detailRow}
                                    key={'detail-transaction-in-asset-title-' + index}>

                                    <TableCell align="center" className={classes.selectableInfo}>
                                        {moment.utc(row.transaction_date).format('DD/MM/YYYY')}
                                    </TableCell>

                                    <TableCell align="center" style={{ fontSize: '10px' }}>
                                        {getOperationLabel(row)}
                                    </TableCell>

                                    {/* <TableCell align="center" >
                                        {applyMaskAccount(row.account)}
                                    </TableCell> */}

                                    {/* <TableCell align="right" className={classes.selectableInfo}>
                                        {row && row.result_qtd_quotas ?
                                            applyMaskAmountFreeDecimals(row.result_qtd_quotas) : '-'}
                                    </TableCell> */}

                                    <TableCell align="right" style={{ color: getOperationColor(row) }}>
                                        {row && row.amount ? applyMaskAmount(row.amount, true) : null}
                                    </TableCell>

                                </TableRow>



                            ))

                        }
                    </TableBody>

                </MyTable>


            }

            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }

        </div >
    );
}



